export const CompleteDocumentSignatureActionDefinition = {
  ActionDefinitionId: 'Internal.CompleteDocumentSignature',
  FieldId_SignatureRequestId: '0146a4a0-8103-431c-bc7a-08a29834437f',
  FieldId_SignatureOutcome: 'e367089c-2261-41ea-b20b-3ae5e47814b4'
} as const;